import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import HeroHome from '../components/HeroHome';
import SeccionQueEs from '../components/SeccionQueEs';
import SeccionDescarga from '../components/SeccionDescarga';
import SeccionRegistro from '../components/SeccionRegistro';
import SeccionPrimeraRifa from '../components/SeccionPrimeraRifa';
import SeccionCambiarEstado from '../components/SeccionCambiarEstado';
import SeccionVenderBoleto from '../components/SeccionVenderBoleto';
import SeccionEstadisticas from '../components/SeccionEstadisticas';
import SeccionPersonalizar from '../components/SeccionPersonalizar';

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollToSection) {
      const sectionId = location.state.scrollToSection;
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [location]);

  return (
    <Box component="main">
      {/* Hero Banner Principal */}
      <HeroHome />

      {/* Secciones de Información y Funcionalidades */}
      <SeccionQueEs />
      <SeccionDescarga />
      <SeccionRegistro />
      <SeccionPrimeraRifa />
      <SeccionVenderBoleto />
      <SeccionCambiarEstado />
      <SeccionEstadisticas />
      <SeccionPersonalizar />
    </Box>
  );
};

export default Home;
